export function formatCustomerName(firstName, lastName) {
  return `${firstName} ${lastName}`;
}

export function formatCustomerEmail(email) {
  return email.toLowerCase();
}
